import { Types } from "../../@types"
import React, { useState, useEffect, useMemo } from "react"
import { X } from "lucide-react";
import { appStore } from "lib/state"
import { appTools, cn, OPERATORS } from "lib/utils"
import { useConditional } from "lib/units/conditional"

/*
  apivalue:
    type,
    hiddenType,
    tag,
    path, 
    origin,
    description
*/


export default function ConditionalStatementButton({ conditionalObj, item, groupref, zoneref, location, ...rest }:any){
  
  const testMode = false

  const { store }:any = appStore()
  const { mergeConditionals, removeConditionalItem }:any = useConditional()

  const [ readyForUse, setReadyForUse ] = useState<boolean>(false)
  const [ testResult, setTestResult ] = useState<any>()
  const [ showRemoveButton, setShowRemoveButton ] = useState<any>()


  function handleButtonDragOver(e:any){
    e.preventDefault()
  }

  function showButtonTag(){
    if( testMode ){
      return item.refid 
    } else {
      if( item.source === "automatic" ){
        return `automatic ${item.value}`
      } else if (item.source === "tag"){
        return item.tag
      } else {
        if( item.alias ){
          return item.alias
        } else if( item.value?.length > 0 ){
          return `${item.apiValueObj?.placeholder} ${ OPERATORS.find( (op:any) => op.value === item.operator)?.symbol || "" } ${item.value || ""}`
        } else {
          return item.apiValueObj?.placeholder
        }
      }
    }
  }

  useEffect(() => {
    if( rest.draggable === true ){
      setReadyForUse(true)
    } else {
      setReadyForUse(false)
    }
  },[item?.operator, item?.value])

  if( !item ) return <></>
  return (
    <div 
      key={item.refid} 
      className={cn(
        "h-8 flex justify-between items-center rounded-sm gap-2 px-2 py-1 cursor-pointer text-sm",
        // group !== undefined && "hover:bg-slate-800",
        item.spotlight === true ? "border-amber-700" : "",
        readyForUse === false && 'opacity-50 cursor-not-allowed',
        location !== 'zone' && 'border border-solid',
        location === 'zone' && testResult?.verdict === true && 'bg-green-700',
        location === 'zone' && testResult?.verdict === false && 'bg-red-900',
      )}
      draggable={ groupref === undefined && zoneref === undefined ? true : false }
      // onDrop={handleButtonDrop}
      // onDragOver={handleButtonDragOver}
      onDragStart={(e) => {
        console.log(item)
        e.dataTransfer.setData("text/plain", JSON.stringify(item))
      }}
      {...rest}
    >
      <span data-type="item" className="text-sm">
        { showButtonTag() }
      </span>
      { location === 'zone' && showRemoveButton === true && (
        <X className="w-4 h-4 text-red-500" onClick={() => removeConditionalItem(item.refid)} />
      )}
    </div>
  )
}